import React from 'react';
import { X } from 'lucide-react';
import type { ApplicantFilter } from '../../types/applicant';

interface ActiveApplicantFiltersProps {
  filters: ApplicantFilter;
  onRemoveFilter: (key: keyof ApplicantFilter) => void;
}

export default function ActiveApplicantFilters({ filters, onRemoveFilter }: ActiveApplicantFiltersProps) {
  const hasActiveFilters = Object.values(filters).some(Boolean);
  
  if (!hasActiveFilters) return null;

  return (
    <div className="flex flex-wrap gap-2">
      {filters.name && (
        <FilterTag
          label="Name"
          value={filters.name}
          onRemove={() => onRemoveFilter('name')}
        />
      )}
      {filters.contactName && (
        <FilterTag
          label="Contact Name"
          value={filters.contactName}
          onRemove={() => onRemoveFilter('contactName')}
        />
      )}
      {filters.email && (
        <FilterTag
          label="Email"
          value={filters.email}
          onRemove={() => onRemoveFilter('email')}
        />
      )}
    </div>
  );
}

interface FilterTagProps {
  label: string;
  value: string;
  onRemove: () => void;
}

function FilterTag({ label, value, onRemove }: FilterTagProps) {
  return (
    <div className="flex items-center gap-1 text-sm bg-gray-100 text-gray-700 px-2 py-1 rounded-md">
      <span className="font-medium">{label}:</span>
      <span>{value}</span>
      <button
        onClick={onRemove}
        className="ml-1 p-0.5 hover:bg-gray-200 rounded-full"
      >
        <X className="h-3 w-3" />
      </button>
    </div>
  );
}
